import { jsx as o } from "react/jsx-runtime";
import "react";
var t = (r) => /* @__PURE__ */ o("svg", {
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...r,
  children: /* @__PURE__ */ o("path", {
    d: "M13.8327 12.6663V10.6663H5.16602C4.06145 10.6663 3.16602 11.5618 3.16602 12.6663M6.36602 14.6663H11.6993C12.4461 14.6663 12.8195 14.6663 13.1047 14.521C13.3556 14.3932 13.5595 14.1892 13.6874 13.9383C13.8327 13.6531 13.8327 13.2797 13.8327 12.533V3.46634C13.8327 2.7196 13.8327 2.34624 13.6874 2.06102C13.5595 1.81014 13.3556 1.60616 13.1047 1.47833C12.8195 1.33301 12.4461 1.33301 11.6993 1.33301H6.36602C5.24591 1.33301 4.68586 1.33301 4.25803 1.55099C3.88171 1.74274 3.57575 2.0487 3.384 2.42503C3.16602 2.85285 3.16602 3.4129 3.16602 4.53301V11.4663C3.16602 12.5864 3.16602 13.1465 3.384 13.5743C3.57575 13.9506 3.88171 14.2566 4.25803 14.4484C4.68586 14.6663 5.24591 14.6663 6.36602 14.6663Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
export {
  t as default
};
